import { Seeder } from '@mikro-orm/seeder';
import { EntityManager } from '@mikro-orm/mysql';
import { Program } from '@/modules/user/entities/program.entity';
import { ProgramType } from '@/modules/user/entities/program-type.entity';

function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export class ProgramsSeeder extends Seeder {
  async run(em: EntityManager): Promise<void> {
    // Map of program -> type names
    const data: Record<string, string[]> = {
      'Four Year Highschool Program': [
        'Sports Student',
        'General Student',
        // 'General Readers',
        // 'Fons of Memoirs & life Stories',
      ],
      'Four Year Degree Program': ['College Student', 'Young Professional'],
      'Doctorate Program': ['Academics', 'Specialized Professional'],
    };

    for (const [programName, typeNames] of Object.entries(data)) {
      // find or create the Program by programName (unique)
      let program = await em.findOne(Program, { name: programName });
      if (!program) {
        program = em.create(Program, {
          name: programName,
          slug: slugify(programName),
          created_at: new Date(),
        });
        em.persist(program);
      }

      for (const typeName of typeNames) {
        const type = await em.findOne(ProgramType, { name: typeName });
        if (!type) {
          // If a type is missing (should be seeded by ProgramTypesSeeder), skip this entry
          continue;
        }
        // attach type to program (ManyToOne side)
        type.program = program;
        em.persist(type);
      }
    }
  }
}
